import { UnknownAction, combineReducers, createAction, Reducer } from '@reduxjs/toolkit';
import appReducer from '../features/app/appSlice';
import conversationsReducer from '../features/conversations/conversationsSlice';
import usersReducer from '../features/users/usersSlice';
import hostContextReducer from '../features/hostContext/hostContextSlice';
import announcementsReducer from '../features/announcements/announcementsSlice';
import escalationOfferReducer from '../features/livechat/escalationOfferSlice';
import agentTypingReducer from '../features/livechat/agentTypingSlice';
import screenshotRequestReducer from '../features/livechat/screenshotRequestSlice';
import { RootState } from './store';

// Define a top-level root state reset action
export const resetApp = createAction('resetApp');

// Define a root reducer that combines all the reducers
const rootReducer: Reducer<RootState> = combineReducers({
    app: appReducer,
    conversations: conversationsReducer,
    users: usersReducer,
    hostContext: hostContextReducer,
    announcements: announcementsReducer,
    escalationOffer: escalationOfferReducer,
    agentTyping: agentTypingReducer,
    screenshotRequest: screenshotRequestReducer,
});

// Define a special resetApp reducer that handles resetting the entire state
export const resetAppReducer = (state: RootState | undefined, action: UnknownAction) => {
    if (action.type === resetApp.type) {
        state = {
            // Explicitly call each individual reducer with undefined state.
            // This allows the reducers to handle the reset logic and return the initial state with the correct type.
            app: appReducer(undefined, action),
            conversations: conversationsReducer(undefined, action),
            users: usersReducer(undefined, action),
            hostContext: hostContextReducer(undefined, action),
            announcements: announcementsReducer(undefined, action),
            escalationOffer: escalationOfferReducer(undefined, action),
            agentTyping: agentTypingReducer(undefined, action),
            screenshotRequest: screenshotRequestReducer(undefined, action),
        };
    }

    return rootReducer(state, action);
};

export default resetAppReducer;
